import React, {useId} from "react";
import Select from "react-select";

const SmallSelect = ({styles: customStyles, instanceId, ...restProps}) =>{
    const selectId = instanceId ?? useId();
    const styles = {
        control: (base) => ({
            ...base,
            minHeight: 'calc(1.5em + 0.5rem + 2px)',
            height: 'calc(1.5em + 0.5rem + 2px)',
            lineHeight: '0.8em',
            fontSize:'0.8em',
            cursor: 'pointer'
        }),
        option: (base) => {
            return ({...base,  cursor: 'pointer'})
        },
        menu: base => ({...base, zIndex: 9999}),
        dropdownIndicator: (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        clearIndicator: (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        valueContainer: (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        ...customStyles
    };

    return <Select instanceId={selectId} styles={styles} {...restProps} />
}

export default SmallSelect;

